import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, ParentDisplayItem, ParentInputItem, ParentProfileDisplayItem, ParentProfileUpdateItem, ParentSearchOptions, ParentToAdultStudentInputItem, ParentUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace ParentRoutes {
    export const Add = ApiRoute.Define({
        URL: 'parents',
        Kind: RequestKind.Post,
        BodyType: ParentInputItem,
        ResultType: string
    });

    export const Search = ApiRoute.Define({
        URL: 'search/parents',
        Kind: RequestKind.Post,
        BodyType: ParentSearchOptions,
        ResultType: DisplayItemCollection<ParentDisplayItem>
    });

    export const GetAll = ApiRoute.Define({
        URL: 'parents',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<ParentDisplayItem>
    });

    export const Update = ApiRoute.Define({
        URL: (parentID: any) => `parents/${parentID}`,
        Kind: RequestKind.Put,
        BodyType: ParentUpdateItem,
        ResultType: boolean
    });

    export const ConvertToStudent = ApiRoute.Define({
        URL: `parents/tostudent`,
        Kind: RequestKind.Post,
        BodyType: ParentToAdultStudentInputItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (parentID: any) => `parents/${parentID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export namespace Profiles {
        export const Get = ApiRoute.Define({
            URL: (id: string) => `parentprofiles/${id}`,
            Kind: RequestKind.Get,
            ResultType: ParentProfileDisplayItem
        });

        export const Update = ApiRoute.Define({
            URL: (id: string) => `parentprofiles/${id}`,
            Kind: RequestKind.Put,
            BodyType: ParentProfileUpdateItem,
            ResultType: boolean
        });
    }
}
